import React, { ReactNode } from 'react'
import { View, ViewStyle } from 'react-native'
import { Button, color } from '@trivie/ui-mobile'
import { Text } from '@trivie/ui-mobile/components/text'

interface SubscriptionLockedScreenProps {
  emoji: string
  title: string
  subtitle?: ReactNode
  helperText: string
  buttonText: string
  onButtonPress?: () => void
}

export const SubscriptionLockedScreen: React.FunctionComponent<SubscriptionLockedScreenProps> = ({
  emoji,
  title,
  subtitle,
  helperText,
  buttonText,
  onButtonPress,
}) => {
  return (
    <View style={CONTAINER}>
      <Text
        variant="headline"
        text={emoji}
        style={{ textAlign: 'center', fontSize: 64, lineHeight: 72 }}
      />
      <Text variant="headline" text={title} style={{ textAlign: 'center', fontSize: 20 }} />
      {subtitle}
      <Text
        variant="body1"
        text={helperText}
        style={{ color: color.shade50, textAlign: 'center', marginTop: 8 }}
      />
      {onButtonPress ? (
        <Button
          variant="compact"
          textStyleOverrides={{ fontSize: 12, lineHeight: 12 }}
          text={buttonText}
          onPress={onButtonPress}
          style={{ marginTop: 32, padding: 4, paddingHorizontal: 8 }}
        />
      ) : null}
    </View>
  )
}

const CONTAINER: ViewStyle = {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  paddingHorizontal: 48,
  top: -60,
}
